export default __webpack_public_path__ + "static/media/d-coin.bae6887f.png";